import { FelaCSSWithCustomSelectors, spacing } from '@bridebook/ui';

interface IStyles {
  container: FelaCSSWithCustomSelectors;
  desktopOnly: FelaCSSWithCustomSelectors;
}

const styles: IStyles = {
  container: {
    overflow: 'auto',
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',

    '@container (width > 768px)': {
      gap: spacing[4],
    },
  },
  desktopOnly: {
    display: 'none',
    '@container (width > 768px)': {
      display: 'flex',
    },
  },
};

export default styles;
